const formatWithSuffix = (count, divisor, suffix) => {
    const val = count / divisor;
    return `${val % 1 === 0 ? val : val.toFixed(1)}${suffix}`;
};
export const formatResultCount = (count) => {
    if (count >= 1000000)
        return formatWithSuffix(count, 1000000, "M+");
    if (count >= 10000)
        return formatWithSuffix(count, 1000, "K");
    return count.toLocaleString();
};
